<div class="login-recovery-option" (click)="goToRecoveryOptionPage()">
  <i class="login-recovery-option__icon {{ iconClassName() }}"></i>
  <div class="login-recovery-option__label">{{ label() }}</div>
  <i class="fa-regular fa-chevron-right"></i>
</div>
